import { __assign } from "tslib";
import { get } from 'lodash';
import { extractTextStyles } from '../../utils/elements';
import { IconSize, IconSpacing } from './types';
export function resolveInnerPadding(data) {
    var size = get(data, 'styles.size');
    var spacingMap = {
        small: IconSpacing.small,
        medium: IconSpacing.medium,
        large: IconSpacing.large,
    };
    var value = parseInt((size && spacingMap[size]) || IconSpacing.medium, 10);
    return "0 " + value / 2 + "px";
}
export function resolveIconSize(data) {
    var size = get(data, 'styles.size');
    var sizeMap = {
        small: IconSize.small,
        medium: IconSize.medium,
        large: IconSize.large,
    };
    return (size && sizeMap[size]) || IconSize.medium;
}
export function resolveTitle(css, data) {
    var titleClassName = 'so-global-h3';
    var defaultTitleStyle = get(css, titleClassName, {});
    var customTitleStyle = get(data, 'styles', {});
    var extractedTextStyles = extractTextStyles(customTitleStyle, defaultTitleStyle);
    var title = data.label
        ? __assign({ text: data.label }, extractedTextStyles) : null;
    return title;
}
//# sourceMappingURL=utils.js.map